// ============================================================================
// Les tuiles d'administration du lanceur — elles suivent le ROLE EN BASE
// ============================================================================
// 2026-09-26, lot feat-l-administration-de-ma-compagnie (section 5 de
// docs/architecture/PROPOSITION-L-ADMINISTRATION-DE-CHAQUE-COMPAGNIE-2026-09-25.md, option A
// rendue par David). La zone d'administration suivait `hasRole(user, GsRole.ADMIN)`, tire des
// GROUPES Entra : un administrateur de compagnie designe dans la Console UG ne voyait pas sa
// tuile, et un membre du groupe voyait GS-Admin qui ne s'ouvrirait pas pour lui
// (E-20260925-tuile-console-ug-du-hub-suit-un-groupe-entra).
//
// Le verdict vient de `/api/me` (`administration`), calcule par la meme primitive que la Console UG
// (`resolveConsoleReadScope`) :
//   - l'organisation (god-view) voit GS-Admin et la Console UG, comme avant ;
//   - l'administrateur d'une ou plusieurs compagnies voit une tuile « Administration — <Compagnie> »
//     par compagnie, qui ouvre la Console UG sur CETTE compagnie ; pas GS-Admin ;
//   - personne d'autre ne voit la zone.
// Une lecture ratee (`mesure: false`) ou absente (serveur plus ancien) ne montre AUCUNE tuile :
// une tuile fausse ferait croire a un acces.
//
// CONFORT D'AFFICHAGE, JAMAIS UNE GARDE : chaque application garde ses portes serveur.

import type { AppDefinition } from '../types';
import type { MeAdministration } from '../hooks/useMe';

export interface TuileAdministration {
  /** Cle React stable : l'app, et la compagnie quand la tuile en vise une. */
  key: string;
  app: AppDefinition;
  /** Nom de la compagnie administree ; absent = la tuile garde le nom du catalogue. */
  compagnie?: string;
}

/** Le parametre que la Console UG lit pour ouvrir la vue d'une compagnie administree. */
export const PARAM_COMPAGNIE = 'compagnie';

/**
 * @param adminApps les applications `adminOnly` du catalogue (GS-Admin `adm`, Console UG `ug`)
 * @param administration le verdict de `/api/me`, ou `undefined` si le serveur ne le rend pas
 */
export function tuilesAdministration(
  adminApps: AppDefinition[],
  administration: MeAdministration | undefined,
): TuileAdministration[] {
  if (!administration || !administration.mesure) return [];
  const { acces, compagnies } = administration;
  if (acces === 'uca' || acces === 'corporate') {
    return adminApps.map((app) => ({ key: app.id, app }));
  }
  if (acces !== 'delegated') return [];
  const ug = adminApps.find((a) => a.id === 'ug');
  if (!ug || !ug.url) return [];
  const base = ug.url.trim();
  const sep = base.includes('?') ? '&' : '?';
  return compagnies.map((c) => ({
    key: `ug:${c.companyId}`,
    app: { ...ug, url: `${base}${sep}${PARAM_COMPAGNIE}=${encodeURIComponent(c.companyId)}` },
    compagnie: c.companyName,
  }));
}
